import type { ScreenFactory } from "../../taskScreenRegistry";

import { createVehiclesScreens } from "./vehicles";
import { createValuablesScreens } from "./valuables";
import { createDepositBoxesScreens } from "./deposit_boxes";

export const personalPropertyTasks: Record<string, ScreenFactory> = {
  vehicles: createVehiclesScreens,
  valuables: createValuablesScreens,
  deposit_boxes: createDepositBoxesScreens,
};
